import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setTokens } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const lang = localStorage.getItem("hr_lang") || "es";
    const target = lang === "es" ? "/es/mi-cuenta" : "/en/my-account";
    if (!sessionId) return navigate(target, { replace: true });
    api
      .post("/auth/session", { session_id: sessionId }, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        setTokens({ session_token: data.session_token });
        setUser(data.user);
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true });
      })
      .catch(() => navigate(lang === "es" ? "/es/iniciar-sesion" : "/en/login", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return <div className="p-16 text-sm text-[#5A5752]">…</div>;
}
